import React from 'react'
import "../Styles/Sustainability.css";

const Sustainablitiy = ({onKnowMoreClick}) => {
  return (
    <div className='Sustainability-container'>
        <div className='Features-contianer Features-container-for-resort' id=''>
        <div className='Features-sub-container'>
            <div className='Features-header-container'>
            <div className='Features-header'>Sustainability at Prasiddh</div>
            <div className='Features-sub-header'>Built to nurture. Designed to endure</div>
            </div>
            <div className='Features-card-holder'>
                <div className='Features-card'>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Rainwater Harvesting</div>
                    <div className='Features-card-content'>Recharges groundwater naturally and reduces water dependency.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Decentralized Wastewater Treatment System</div>
                    <div className='Features-card-content'>Natural greywater recycling for reuse in landscaping and flushing.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Compressed Stabilized Earth Blocks</div>
                    <div className='Features-card-content'>Eco-friendly earth blocks that cut down carbon and keep homes cool.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className=''>
                    <div className='Features-card-header'>Eco Integrated with Bali Inspired Landscape</div>
                    <div className='Features-card-content'>Native greenery that supports biodiversity and cools the microclimate.</div>
                </div>
            </div>
            </div>

            <div className='Features-enquire-now-button-holder'>
                <button className='Features-enquire-now-button' onClick={onKnowMoreClick}>Know Now</button>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Sustainablitiy
